const TYPES = ['rock', 'paper', 'scissors'];
const COMPUTER_PICK_TIME = 300;

export { TYPES, COMPUTER_PICK_TIME };
